const destroy = () => {
  // destroy phase
};

export default destroy;
